import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';
import { userFavoritesResModel, virtualCardsResModel } from 'src/app/home/models/favoriteResponse.model';
import { CardMatchValidator } from '../../utility-classes/card-match-validator';
import { ModalActionsFactory } from '../../utility-classes/modal-actions';

@Component({
  selector: 'app-card-buttons',
  templateUrl: './card-buttons.component.html',
  styleUrls: ['./card-buttons.component.scss', '../../../../home/home.component.scss']
})
export class CardButtonsComponent implements OnInit {
  @Input() card!: cardDetailResModel;
  @Input() type!:string;

  constructor(
    private toastr:ToastrService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

  onClick_favOnlineCharge() {
    new CardMatchValidator(this.card, this.toastr).matchFavoritesAndCards(
      () => {
        const modalAction = new ModalActionsFactory(this.modalService).getModalAction('OnlineChargeFav')
        modalAction.openModal();
        modalAction.setInput!(this.type);    
      }
    )
  }

  onClick_cardDetail() {
    const modalAction = new ModalActionsFactory(this.modalService).getModalAction('CardDetail')
    modalAction.openModal();
    modalAction.setInput!(this.type);
  }

}
